import React, {FC, useMemo} from 'react';

//MUI
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

//GEOCOMPONENTS
import MapLegend from '@geomatico/geocomponents/Map/MapLegend';
import SelectInput from '@geomatico/geocomponents/Forms/SelectInput';

//UTILS
import {useTranslation} from 'react-i18next';
import {SxProps} from '@mui/system/styleFunctionSx/styleFunctionSx';
import {OWNERS, VIEW_BY_OPTIONS} from '@/config';
import {Crop, Use, ViewBy} from '@/domain/services/Clas';
import {getLegendByView} from '@/domain/useCases/getLegendByView';
import {capitalize} from '@/domain/useCases/capitalize';

export interface ViewSelectorProps {
  crops?: Array<Crop>,
  uses?: Array<Use>,
  viewBy: ViewBy,
  onViewByChange: (viewBy: string) => void
}

const ViewSelector: FC<ViewSelectorProps> = ({
  crops,
  uses,
  viewBy,
  onViewByChange }) => {

  const {t} = useTranslation();

  const handleOptionChange = (optionId: string) => {
    if(!optionId) return;
    if(Object.values(ViewBy).includes(optionId as ViewBy)) {
      onViewByChange(optionId as ViewBy);
    }
  };

  const viewOptions = Object.values(VIEW_BY_OPTIONS)
    .map(viewBy => ({id: viewBy, label: capitalize(t(`viewBy.${viewBy}`))}));

  const fields = useMemo(() =>
    crops && uses && getLegendByView(crops, uses, OWNERS, viewBy)
  , [crops, uses, viewBy]);

  return <Paper sx={viewByPaperSx}>
    <Typography variant='overline'>{t('viewBy.title')}</Typography>
    <SelectInput options={viewOptions}
      onOptionChange={(optionId?: string) => optionId && handleOptionChange(optionId as ViewBy)}
      selectedOptionId={viewBy as string}
      sx={select} menuSx={menuSelect}/>
    <Box sx={{maxHeight: '75vh', overflow: 'auto', pl: 0.5}}>
      {fields && <MapLegend fields={fields} sx={legend}/>}
    </Box>
  </Paper>;
};

export default ViewSelector;

const legend: SxProps = {
  '& .MapLegend-swatch': {
    margin: '0px 10px 0px 0px',
    width: 25,
    height: 14,
    borderRadius: '100%'
  },
  '& .MapLegend-text': {
    fontSize: 12,
    textTransform: 'capitalize'
  }
};

const select: SxProps = {
  width: '100%',
  '& .SelectInput-select': {//La opción seleccionada del selector
  }
};

const menuSelect: SxProps = {
  '& .SelectInput-menuItem': {
  }
};

const viewByPaperSx: SxProps = {
  position: 'absolute',
  top: 10,
  left: 10,
  zIndex: 1000,
  opacity: 0.85,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  p: 1,
  backgroundColor: 'white',
  borderRadius: 1,
  boxShadow: '0',
  width: 250
};